import React, { type ComponentProps } from 'react';
import { PromptMomentNotification } from 'google-one-tap';
import { Container } from '@fiverr-private/layout_components';
import { useGoogleOneTap } from '../../../hooks/useGoogleOneTap';
import { GOOGLE_ONE_TAP_PARENT_CONTAINER_ID } from '../../../shared/constants/googleOneTap';
import { AuthenticationResponse } from '../../../shared/constants/authenticationFlow';

type ContainerProps = ComponentProps<typeof Container>;

interface GoogleOneTapCoreProps {
    googleClientId: string;
    onSdkLoadSuccess?: () => void;
    onSdkLoadError?: () => void;
    onOneTapCallback?: () => void;
    onOneTapSuccess: (response: AuthenticationResponse) => void;
    onOneTapError: (response: AuthenticationResponse) => void;
    onNotificationReceived: (notification: PromptMomentNotification) => void;
    isFedCMAvailable?: boolean;
}

const iframeStyles: ContainerProps = {
    zIndex: 'popover',
    position: 'fixed',
    right: '32px',
    top: '64px',
};

export const GoogleOneTapCore = ({
    googleClientId,
    onSdkLoadSuccess,
    onSdkLoadError,
    onOneTapCallback,
    onOneTapSuccess,
    onOneTapError,
    onNotificationReceived,
    isFedCMAvailable,
}: GoogleOneTapCoreProps) => {
    const { isSdkLoaded } = useGoogleOneTap({
        googleClientId,
        onSdkLoadSuccess,
        onSdkLoadError,
        onOneTapCallback,
        onOneTapSuccess,
        onOneTapError,
        onNotificationReceived,
        isFedCMAvailable,
    });

    if (!isSdkLoaded) {
        return null;
    }

    const styles = isFedCMAvailable ? {} : iframeStyles;

    return (
        <Container
            id={GOOGLE_ONE_TAP_PARENT_CONTAINER_ID}
            data-testid={GOOGLE_ONE_TAP_PARENT_CONTAINER_ID}
            {...styles}
        />
    );
};
